<template>
    <div class="post">
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="576px"
            :before-close="handleClose"
        >
            <div class="form">
                <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                >
                    <el-form-item label="快递公司：" prop="name">
                        <el-select
                            v-model="ruleForm.company"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            placeholder="请输入关键词"
                            :remote-method="remoteMethod"
                            :loading="loading"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.text"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单编号：" prop="name">
                        <el-input
                            v-model="ruleForm.number"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="postFun" :loading="btnload"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            btnload: false,
            loading: false,
            ruleForm: {
                company: "",
                number: "",
            },
            rules: {
                company: [
                    {
                        required: true,
                        message: "请输入快递公司",
                        trigger: "blur",
                    },
                ],
                number: [
                    {
                        required: true,
                        message: "请输入快递单号",
                        trigger: "blur",
                    },
                ],
            },
            options: [],
            list: [],
            dialogVisible: false,
            rowData: null,
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getCompanyList();
    },
    methods: {
        ...mapActions({
            posterMail: "commodity/posterMail",
            posterExpressList: "commodity/posterExpressList",
        }),

        remoteMethod(query) {
            if (query !== "") {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.list.filter((item) => {
                        return (
                            item.text
                                .toLowerCase()
                                .indexOf(query.toLowerCase()) > -1
                        );
                    });
                }, 200);
            } else {
                this.options = [];
            }
        },
        handleClose() {
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.ruleForm.company = "";
        },
        postFun() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.btnload = true;
                    let company = this.options.filter((item) => {
                        return item.id == this.ruleForm.company;
                    });
                    let opt = {
                        token: this.getToken,
                        id: this.rowData.id, //所选数据id
                        shop_id: this.rowData.shop_id, //店铺id
                        express_id: this.ruleForm.company, //快递名称id
                        express_name: company[0].text, //快递名称
                        express_no: this.ruleForm.number, //快递单号
                    };
                    this.posterMail(opt).then((res) => {
                        this.btnload = false;
                        if (res.code == 1) {
                            this.handleClose();
                            this.$message.success("提交成功！");
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        getCompanyList() {
            this.posterExpressList({ token: this.getToken }).then((res) => {
                if (res.code == 1) {
                    if (res.data.length > 0) {
                        res.data.forEach((item) => {
                            this.list.push(item);
                        });
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>